export enum WORK_ORDER_STATE {
  CREATE_WORK_ORDER = 'CREATE_WORK_ORDER',
  FILLING_NOTARY_FORM_DATA = 'FILLING_NOTARY_FORM_DATA',
  NOTARY_FORM_SUBMIT = 'NOTARY_FORM_SUBMIT',
  NOTARY_WORKING_ON_REQUEST = 'NOTARY_WORKING_ON_REQUEST',
  WORK_ORDER_COMPLETED = 'WORK_ORDER_COMPLETED',
}
